import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Portfolio } from '../components/Portfolio';
import { Businesses } from '../components/Businesses';
import { Story } from '../components/Story';
import { Awards } from '../components/Awards';
import { Testimonials } from '../components/Testimonials';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
interface LandingPageProps {
  onNavigate?: (page: 'home' | 'about' | 'business', slug?: string) => void;
}
export function LandingPage({
  onNavigate
}: LandingPageProps) {
  return <main className="min-h-screen bg-white" data-id="element-454">
      <Hero data-id="element-455" />
      <Stats data-id="element-456" />
      <Portfolio onNavigate={onNavigate} data-id="element-457" />
      <Businesses onNavigate={onNavigate} data-id="element-458" />
      <Story data-id="element-459" />
      <Awards data-id="element-460" />
      <Testimonials data-id="element-461" />
      <Newsletter data-id="element-462" />
      <Footer data-id="element-463" />
    </main>;
}